// Full-document render of the loadup (mattress pickup request) confirmation
// page: PageSkeleton wrapping the account-page layout with the static
// thank-you copy. The legacy stearns loadup views 500'd (no template), so
// there is no legacy stearns render to match; this ships the standard TSI
// confirmation copy. Stearns serves en-us only, so the plain literals need no
// runtime localization.
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoadupRequestConfirmationDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <header>
                    <h2>Mattress Pickup Request</h2>
                </header>

                <div className="account-form">
                    <p>
                        Thank you for submitting a Mattress Pickup Request Form!
                    </p>
                    <p>
                        Please allow 1-3 business days for our pickup partners
                        to email you for scheduling.
                    </p>
                </div>
            </div>
        </PageSkeleton>
    );
};
